import { SocialLink } from 'shared/interfaces';
import lidraughtsIcon from 'assets/images/social/lidraughts-icon.svg';

export const LIDRAUGHTS_SOCIAL_LINKS: SocialLink[] = [
  {
    label: 'Website',
    icon: lidraughtsIcon,
    link: 'https://lidraughts.org/',
  },
];
